export const LOANS_REQUEST : string = 'LOANS_REQUEST'
export const LOANS_SUCCESS : string = 'LOANS_SUCCESS'
export const LOANS_FAIL : string = 'LOANS_FAIL'
